import { render, staticRenderFns } from "./ThreeJSComponent.vue?vue&type=template&id=b897b76c&scoped=true"
import script from "./ThreeJSComponent.vue?vue&type=script&lang=js"
export * from "./ThreeJSComponent.vue?vue&type=script&lang=js"
import style0 from "./ThreeJSComponent.vue?vue&type=style&index=0&id=b897b76c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b897b76c",
  null
  
)

export default component.exports